import * as v from "valibot";

/**
 * Secret item schema：用于 CA 证书下拉选择。
 * 仅含展示字段，MUST NOT 包含 `data` 字段（凭据数据不进入前端）。
 */
export const SecretItemSchema = v.object({
  metadata: v.object({
    name: v.optional(v.string()),
    namespace: v.optional(v.string()),
    creationTimestamp: v.optional(v.string()),
  }),
  type: v.optional(v.string()),
});
export type SecretItem = v.InferOutput<typeof SecretItemSchema>;
